// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delivery {
  padding-top: 15px;
  padding-bottom: 10px;
  justify-content: center;
  padding-bottom: 10px;
}
.btn-delivery-main {
  box-shadow: 4px 4px 8px var(--shadow);
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  width: 197px;
  height: 65px;
  border-radius: 4px; 
}
.btn-delivery {
  box-shadow: 4px 4px 8px var(--shadow);
  margin-bottom: 10px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  width: 65px;
  height: 65px;
  border-radius: 4px;
  background-color: aliceblue;
}
@media (min-width: 768px) {
  .delivery p{
    padding-left: 400px;
    padding-right: 400px;
  }
  .delivery h4{
    padding-left: 400px;
    padding-right: 400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/delivery.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF","sourcesContent":[".delivery {\n  padding-top: 15px;\n  padding-bottom: 10px;\n  justify-content: center;\n  padding-bottom: 10px;\n}\n.btn-delivery-main {\n  box-shadow: 4px 4px 8px var(--shadow);\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 2.5px;\n  margin-right: 2.5px;\n  width: 197px;\n  height: 65px;\n  border-radius: 4px; \n}\n.btn-delivery {\n  box-shadow: 4px 4px 8px var(--shadow);\n  margin-bottom: 10px;\n  margin-left: 2.5px;\n  margin-right: 2.5px;\n  width: 65px;\n  height: 65px;\n  border-radius: 4px;\n  background-color: aliceblue;\n}\n@media (min-width: 768px) {\n  .delivery p{\n    padding-left: 400px;\n    padding-right: 400px;\n  }\n  .delivery h4{\n    padding-left: 400px;\n    padding-right: 400px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
